import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1723310688650304');
    window.fbq('track', 'PageView');
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1723310688650304&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
    </>;
}